export default "__VITE_ASSET__AKkdRUa5__"